<template>
<ScreenLayout left-wider>
    <div slot="header">
        <v-toolbar slot="header" dark dense class="primary no-print">
        <v-btn @click.native="$router.push('/home')" icon>
            <v-icon>home</v-icon>
        </v-btn>
        <v-toolbar-title>Taco Email Logs</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu v-if="this.loading == 'loaded'" offset-y left>
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">more_vert</v-icon>
            </template>
            <v-list>
                <v-list-item v-if="isAdministrator" @click="showAll">
                    <v-list-item-title>Show All</v-list-item-title>
                </v-list-item>
                <v-list-item @click="testMail('sendgrid')">
                    <v-list-item-title>Send Me a Test</v-list-item-title>
                </v-list-item>
                <v-list-item @click="testMail('smtp2go')">
                    <v-list-item-title>Send Me Test via Smtp2Go</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isAdministrator" @click="openConsole">
                    <v-list-item-title>Open in Console</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-progress-circular @click="this.loading = ''" v-if="this.loading == 'loading'" indeterminate class="white--text"></v-progress-circular>


        </v-toolbar>
    </div>

    <div slot="left" class="grey lighten-2">
        <v-chip @click:close="setEmail(null)" class="ma-3" color="primary" close v-if="email">{{email.split('@')[0]}}</v-chip>
        <div v-for="(log, logIndex) in logs" @click="selectLog(log._id)" :key="logIndex" class="clickable log-tile" :class="{'blue-hilight': isLogSelected(log)}">
            <div class="bullet" :class="{'green':logAllSuccessful(log), 'red':logHasProblems(log)}"></div>
            <b>{{ summariseTo(log.email.to) }}</b> <span class="small-text light-text">{{log.createdAt | shortDate}}</span><br/>
            {{log.email.subject}}
        </div>
        <div class="pa-2" v-if="this.limit == this.logs.length">
            <v-btn @click="limit = limit + 100" class="full-width" rounded depressed>More</v-btn>
        </div>
    </div>

    <!-- Main Body -->
    <div>
        <div class="pa-5 main-content" v-if="this.logId && this.loading == 'loaded'">
            <div class="pa-3 white rounded elevation-0">
                <table>
                    <tr>
                        <td class="layout-heading">To</td>
                        <td>{{listTo(selectedLog.email.to)}}</td>
                    </tr>
                    <tr v-if="listTo(selectedLog.email.cc)">
                        <td class="layout-heading">Cc</td>
                        <td>{{listTo(selectedLog.email.cc)}}</td>
                    </tr>
                    <tr v-if="listTo(selectedLog.email.bcc)">
                        <td class="layout-heading">Bcc</td>
                        <td>{{listTo(selectedLog.email.bcc)}}</td>
                    </tr>
                    <tr>
                        <td class="layout-heading">From</td>
                        <td>{{selectedLog.email.from}}</td>
                    </tr>
                    <tr>
                        <td class="layout-heading">Subject</td>
                        <td>{{selectedLog.email.subject}}</td>
                    </tr>
                    <tr v-if="selectedLog.email.attachments && selectedLog.email.attachments.length">
                        <td class="layout-heading">Files</td>
                        <td v-html="attachmentsToHtml(selectedLog.email.attachments)">
                        </td>
                    </tr>
                    <tr>
                        <!-- <td  class="layout-heading">Body</td> -->
                        <td colspan="2">
                            <div style="border-top:solid 1px #ddd; padding-top:12px; margin-top:7px" v-html="selectedLog.email.body"></div>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Advanced Panel -->
            <v-btn @click="advanced = true" depressed rounded v-if="!advanced" class="mt-5">Advanced</v-btn>
            <v-btn @click="resend" depressed rounded class="mt-5 ml-2">Resend</v-btn>


            <div v-if="advanced && selectedLog.info" class="pa-3 white rounded elevation-2 mt-3 word-wrap">
                <b>Accepted addresses:</b><br>

                <div v-for="(address, index) in selectedLog.info.accepted" :key="index">
                    {{address}}
                </div>
                <b>Rejected addresses:</b><br>
                <div v-for="(address, index) in selectedLog.info.rejected" :key="index">
                    {{address}}
                </div>
                <div v-if="selectedLog.info.rejected.length === 0">None</div>
                <br>
                <b>Nerdy Stuff</b><br>
                mailId: {{selectedLog.mailId}}
                sendgridId: {{selectedLog.sendgridId}}
                {{JSON.stringify(selectedLog.info)}}
                <br>
                <b>Statuses</b>
                <div v-for="(statusVal, statusName, index) in selectedLog.statuses" :key="'sts-' + index">
                    <b>{{statusName}}</b> {{statusVal}}
                </div>
                <b>Events</b>
                <div v-for="(event, eventName, index) in selectedLog.events" :key="'evt-' + index">
                    <b>{{eventName}}</b>
                    {{JSON.stringify(event)}}
                </div>
                <b>Activity</b>
                <div v-for="(activity, index) in selectedLog.activities" :key="'act-' + index">
                    <b>{{activity.event}}</b> {{JSON.stringify(activity)}}
                </div>
                <b>Email</b>
                {{JSON.stringify(selectedLog.email)}}
            </div>
        </div>
    </div>

    <!-- Right panel - status timeline -->

    <div slot="right">
        <div v-if="selectedLog._id" class="pa-6 ma-5 white rounded activity-panel">

            <div v-if="queuedActivity(selectedLog)" style="display:flex">
                <v-icon class="blue--text" style="margin-left:8px;margin-right:5px;">view_week</v-icon>
                <div class="activity-description">{{queuedActivity(selectedLog).event}} {{queuedActivity(selectedLog).time | time}}</div>
            </div>

            <div class="vertical-line show-line">

            </div>

            <div v-if="sentActivity(selectedLog)" style="display:flex">
                <v-icon class="blue--text" style="margin-left:8px;margin-right:5px;">local_post_office</v-icon>
                <div class="activity-description">{{sentActivity(selectedLog).event}} {{sentActivity(selectedLog).time | time}}</div>
            </div>

            <div class="vertical-line show-line">

            </div>

            <!-- Recipients -->
            <template v-if="selectedLog.info">
            <div v-for="(email, index) in selectedLog.info.accepted" style="font-size:12px" :key="'eml-' + index">

                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <!-- <v-btn color="primary"  v-on="on" dark>Button</v-btn> -->
                    <div @click="setEmail(email)" v-on="on" class="recipient-bubble hoverable clickable" style="display:flex">
                        <v-icon class="mr-1 grey--text">account_circle</v-icon>
                        <div>
                            <div style="font-size:14px;margin-top:-2px">{{email.split('@')[0]}}</div>
                            <div style="font-size:10px;margin-top:-3px;color:#777">@{{email.split('@')[1]}}</div>
                        </div>
                    </div>
                  </template>
                  <span>See all my emails to {{email.split('@')[0]}}</span>
                </v-tooltip>

                <div class="vertical-line show-line"></div>
                <div v-for="(activity, index) in getActivitiesForEmail(email)" :key="'ue-' + index">
                    <div style="display:flex">
                        <v-icon v-if="activity.event != 'deferred' && activity.event != 'bounce' && activity.event != 'open' && activity.event != 'dropped'" class="activity-icon blue--text" >check_circle</v-icon>
                        <v-icon v-if="activity.event == 'deferred'" class="activity-icon orange--text">watch_later</v-icon>
                        <v-icon v-if="activity.event == 'bounce' || activity.event == 'dropped'" class="activity-icon red--text">offline_bolt</v-icon>
                        <v-icon v-if="activity.event == 'open'" class="activity-icon blue--text">account_circle</v-icon>
                        <div class="activity-description">{{activity.event}} {{activity.time | time}}</div>
                    </div>
                    <div class="vertical-line" :class="{'show-line':(index < getActivitiesForEmail(email).length - 1)}">
                        {{activity.message}}
                    </div>
                </div>
            </div>
            <div style="margin-bottom:-10px"></div>
            </template>
        </div>
        <div class="pl-5 small-text light-text">
            Sent with Taco {{selectedLog.provider}}
        </div>
    </div>

    <EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" />

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import Firestore from '../data/Firestore'
import RouterHelpers from '../helpers/RouterHelpers'
import {formatDistanceStrict} from 'date-fns'
import EmailHelpers from '../helpers/EmailHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import Utilities from '../helpers/Utilities'
import EmailDialog from '../ui-elements/EmailDialog'


export default {
name: 'MailLog',
components: {ScreenLayout, EmailDialog},
props: {
    logId: String,
    email: String,
},
data() {
    return {
        limit: 100,
        logs: [],
        loading: 'loading',
        advanced: false,
        showingAll: false,
        emailDialog: {

            email: {
                to: null,
                cc: null,
                bcc: null,
                subject: null,
                body: '',
                attachments: [],
            },
            settings: {
                visible: false,
                sent: false,
            },

        },
    }
},
computed:{
    allParams() {
        return this.showingAll + this.email + this.limit
    },
    selectedLog() {
        return this.logs.find(o => o._id == this.logId) || {email: {}, statuses: {}, activities: [], info:{} }
    },
    user() {
        return DataHelpers.getUser()
    },
    isAdministrator() {
        return (this.user.email == "matt.ireland.home@gmail.com")
    },
    bounceReason() {

        return this.selectedLog.events.bounce.reason
    },
    selectedLogRecipientName() {
        return this.summariseTo(this.selectedLog.email.to)
    }

},
methods: {

    resend() {
        this.emailDialog.email = {...this.selectedLog.email}
        this.emailDialog.settings.sent = true
        this.emailDialog.settings.visible = true
    },

    openConsole() {
        Firestore.openConsole(this.selectedLog._path + '/' + this.selectedLog._id)
    },
    sentActivity(log) {
        if(!log || !log.activities)
            return null
        return log.activities.find(o => o.event == 'sent')
    },
    queuedActivity(log) {
        if(!log || !log.activities)
            return false
        return log.activities.find(o => o.event == 'queued')
    },

    logHasProblems(log) {
        if(!log || !log.activities)
            return false

        const badEvent = log.activities.find(o => o.event == 'bounce' || o.event == 'dropped')
        return Boolean(badEvent)
    },
    logAllSuccessful(log) {
        if(!log || !log.activities)
            return false

        const opened = Boolean(log.activities.find(o => o.event == 'open') )
        if(opened && !this.logHasProblems(log))
            return true
        else
            return false
    },

    isLogSelected(log) {
        return log == this.selectedLog
    },

    attachmentsToHtml(attachments) {
        let str = ''
        attachments.forEach(attachment => {
            str += `
            <style>
                .attachment-button:hover {
                    background-color: #eee;
                }
            </style>
            <a href="${attachment.path}" target="_blank" style="text-decoration:none;">
            <div style="margin:0 3px 3px 0px;padding:3px 10px;border:solid 1px #ccc;border-radius:14px;display:inline-block;" class="attachment-button">
                ${attachment.filename}
            </div>
            </a>
            `
        })
        return str
    },
    // statusExists(status) {
    //     const s = status.toLowerCase()
    //     return (this.selectedLog.statuses[s])
    // },

    // statusTime(status) {
    //     return this.selectedLog.statuses[status + '_date']
    // },

    // timeBetween(start, finish) {
    //     const startTime = DateHelpers.toDate(this.statusTime(start))
    //     const finishTime = DateHelpers.toDate(this.statusTime(finish))
    //     if(!startTime || !finishTime)
    //         return '.'
    //     return formatDistanceStrict(startTime, finishTime)
    // },

    // statusIconClass(status) {
    //     if(this.statusExists(status))
    //         return "blue--text"
    //     else
    //         return "grey--text text--lighten-2"
    // },
    // statusTextClass(status) {
    //     if(this.statusExists(status))
    //         return "grey--text text--darken-1"
    //     else
    //         return "grey--text text--lighten-2"
    // },
    async load() {
        this.loading = 'loading'
        console.log('loading logs...')
        const mailRef = Firestore.getCollectionDocumentRefFromPath('teams/global/collections/mail/data')
        let ref = mailRef
        if(!this.showingAll)
            ref = ref.where('createdBy', '==', this.user.uid)
        if(this.email) {
            ref = ref.where('info.accepted', 'array-contains', this.email)
        }
        ref = ref.orderBy('createdAt', 'desc').limit(this.limit)
        await Firestore.streamCollection(ref, this.logs)
        if(!this.logId) {
            const logId = this.logs[0]._id
            RouterHelpers.setQueryParameter(this, 'l', logId)
        }
        this.loading = 'loaded'
        this.advanced = false
    },
    selectLog(logId) {
        //console.log('selecting log', logId)
        RouterHelpers.setQueryParameter(this, 'l', logId)
        this.advanced = false
    },

    setEmail(email) {
        RouterHelpers.setQueryParameter(this, 'e', email)
    },

    listTo(arrayOfContacts) {
        if(!arrayOfContacts || !Array.isArray(arrayOfContacts))
            return ''
        return arrayOfContacts.map(o => ( o.hasOwnProperty('email') ? o.email : o) ).join('; ')
    },

    summariseTo(arrayOfContacts) {
        if(!arrayOfContacts || !Array.isArray(arrayOfContacts))
            return ''

        return arrayOfContacts.map(o => {
            const email = (o.hasOwnProperty('email') ? o.email : o).split('@')[0].trim()
            if(email)
                return email
        }).join(', ')
    },

    showAll() {
        if(!this.isAdministrator)
            return
        this.showingAll = true
        // this.load()
    },

    getActivitiesForEmail(email) {
        if(!this.selectedLog.activities)
            return []
        return this.selectedLog.activities.filter(o => o.email == email)
    },

    testMail(provider) {
        const mail = {
            provider: provider,
            fromName: 'Taco Testing',
            from: 'no-reply@insightprocessing.com.au',
            to: [this.user.email],
            cc: ['email-log-test@insightprocessing.com.au'],
            subject: 'Taco Test Email',
            body: '<b>Test Message</b> from Taco with attachment',
            attachments:[
                {
                    filename: "Email Worked.jpg",
                    path: "https://i.imgur.com/UwMBztL.jpg"
                },
            ]
        }
        const logId = EmailHelpers.queueEmail(mail)
        AlertHelpers.showAlert('Sent Test...Loading in Mail Monitor')
        setTimeout( () => {
            this.selectLog(logId)
        }, 3000)
    }
},

async created() {
    await DataHelpers.fetchUser()
    this.load()
},

mounted() {
    console.log(this.$root)
},

watch: {
    allParams: {
        immediate: false,
        handler: function() {
            this.load()
        }
    },
}

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .activity-panel {
        font-size:13px;
    }
    .activity-icon {
        margin-left:8px;margin-right:5px;
    }

    .bullet {
        display: inline-block;
        width: 10px; height: 10px;
        border-radius:5px;
        background-color: #ccc;
    }

    .word-wrap {
        word-wrap: break-word;
    }

    .log-tile {
        padding:8px 14px;
        font-size: 14px;
        background-color:#fff;
        margin-bottom:1px;
        font-weight:300;
    }
    .log-tile:hover {
        background-color: #f5f5f5;
    }

    td {
        padding:3px 6px;;
        font-size:14px;
    }
    .layout-heading {
        text-align: right;
        font-weight: 600;
        vertical-align: top;
        width:80px;
    }
    .main-content {
        font-weight:300;
        font-size: 14px;
    }
    .vertical-line {
        position: relative;
        padding:5px 5px 5px 35px;
        color: #bbb;
        font-size:12px;
        min-height:15px;
    }
    .vertical-line.show-line::after{
        position:absolute;
        content:"";
        display:block;
        height: 100%;
        width:3px;
        background-color: #ccc;
        top:0px;
        left: 18px;
    }

    .status-bar {
        color: #bbb;
        font-size: 14px;
    }

    .recipient-bubble {
        margin-left:-3px;
        font-size:12px;
        border: dotted 1px #bbb;
        border-radius: 20px;
        padding: 4px 10px;
        height: 40px;
        background-color:#eee;
    }

    .activity-description {
        padding-top:2px;
    }

    /* .status-icon::after{
        margin-top:-50px;
        margin-right: 20px;
    } */

</style>


// WEBPACK FOOTER //
// MailLog.vue?88c53f16